<template>
  <section class="note">
    <div class="inputWrapper">
      <el-input type="textarea" placeholder="请输入你的笔记…" v-model="textarea" maxlength="500" show-word-limit rows="6" @input="inputChange">
      </el-input>
      <div class="button-submit">
        <el-button type="primary" :disabled="!isComment" @click="commentNote">提交</el-button>
      </div>
    </div>

    <div class="noteList">
      <h2 class="title">笔记内容</h2>
      <div v-if="noteList.length>0">
        <div v-for="(item,index) in noteList" :key="index">
          <div v-if="!item.noteEdit" class="list">
            <h3 class="name">{{item.classTimeName}}</h3>
            <p class="content">{{item.noteDetails}}</p>
            <div v-if="item.reviewStatus === 0" class="prohibited-box">违禁原因：{{item.illegalReason}}</div>
            <div class="dateWrapper">
              <time class="date">{{item.updateTime}} 发布</time>
              <div class="operation">
                <div v-if="item.reviewStatus === 1" @click="editNote(item)">
                  <i class="edit-icon"></i>
                  <span>编辑</span>
                </div>
                <div @click="deleteNote(item.id)">
                  <i class="delete-icon"></i>
                  <span>删除</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.noteEdit && noteId === item.id" class="inputWrapper">
            <el-input type="textarea" placeholder="请输入你的笔记…" v-model="itemTextarea" maxlength="500" show-word-limit rows="6" @input="itemInputChange">
            </el-input>
            <div class="button-submit">
              <el-button class="quit-button" @click="quitEdit">取消</el-button>
              <el-button type="primary" :disabled="!canEdit" @click="editNoteDes(item.id)">提交</el-button>
            </div>
          </div>
        </div>
      </div>
      <NotData v-else :top="80"></NotData>
    </div>
    <!-- 删除弹窗 -->
    <ConfirmDialog :isShowConfirm="isShowDeleteDialog" title="删除提示" content="删除后内容不保留，是否确认删除" @handleClose="isShowDeleteDialog = false" @handleConfirm="deleteCommit"></ConfirmDialog>
    <!-- 违禁弹窗 -->
    <ConfirmDialog :isShowConfirm="isShowContrabandConfirm" title="" :isOneBtn="true" content="您提交的笔记涉及违禁词，请修改后提交" @handleConfirm="isShowContrabandConfirm=false" @handleClose="isShowContrabandConfirm = false"></ConfirmDialog>
  </section>
</template>

<script>
import { courseStore } from "@/store/course.js";
export default {
  name: 'CourseNote',
  data() {
    return {
      store: courseStore(),
      // 提交的内容
      textarea: '',
      // 是否可以提交
      isComment: false,
      // 分页
      pageNum: 1,
      pageSize: 2000,
      // 笔记列表
      noteList: [],
      // 删除笔记确认弹窗
      isShowDeleteDialog: false,
      // 违禁笔记弹窗
      isShowContrabandConfirm: false,
      // 笔记id
      noteId: '',
      // 修改评论是否可以提交
      canEdit: true,
      // 修改评论输入值
      itemTextarea: ''
    }
  },
  created() {
    this.getNoteList()
  },
  methods: {
    // 监听输入框
    inputChange(val) {
      if (val !== '') this.isComment = true
      else this.isComment = false
    },
    // 笔记提交
    commentNote() {

      if (!this.isComment) return

      // 从商店取当前课次信息
      const courseInfo = this.store.getCourseInfo
      this.$axios.$post('/behavior/note/insert', {
        projectId: courseInfo.projectId,
        courseId: courseInfo.courseId,
        classTimeId: courseInfo.lessonId,
        noteDetails: this.textarea
      }).then(res => {
        this.textarea = ''
        this.$message.success('笔记提交成功');
        this.getNoteList()
      }).catch((err) => {
        this.isShowContrabandConfirm = true
      })
    },
    // 点击笔记编辑
    editNote(item) {
      this.noteId = item.id
      this.itemTextarea = item.noteDetails
      this.noteList.map((list, index) => {
        if (list.id === item.id) {
          list.noteEdit = true
          this.$set(this.noteList, index, list)
        } else {
          list.noteEdit = false
          this.$set(this.noteList, index, list)
        }
      })
    },
    // 笔记修改
    editNoteDes(id) {
      if (!this.canEdit) return

      this.$axios.$post('/behavior/note/update', {
        id: id,
        noteDetails: this.itemTextarea
      }).then(res => {
        this.$message.success('笔记修改成功');
        this.getNoteList()
      }).catch(() => { })
    },
    // 取消修改
    quitEdit() {
      this.noteList.map((item, index) => {
        item.noteEdit = false
        this.$set(this.noteList, index, item)
      })
    },
    // 修改输入框值改变时
    itemInputChange(val) {
      if (val !== '') this.canEdit = true
      else this.canEdit = false
    },
    // 删除笔记
    deleteNote(id) {
      this.noteId = id
      this.isShowDeleteDialog = true
    },
    // 删除笔记确认按钮
    deleteCommit() {
      this.$axios.$get(`/behavior/note/delete/${this.noteId}`).then(res => {
        this.$message.success('笔记删除成功');
        this.isShowDeleteDialog = false
        this.getNoteList()
      }).catch(() => { })
    },
    // 笔记列表
    getNoteList() {
      this.$axios.$post(`/behavior/note/selectPageList`, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        projectId: this.$route.params.id,
        reviewStatus: '', // 是否审核 0:审核 1:未审核 
        noteDetails: this.textarea,
      }).then(res => {
        this.noteList = res.list
      }).catch(() => { })
    },
  }
}
</script>

<style lang="scss" scoped>
.note {
  padding-top: 30px;
  .inputWrapper {
    border-bottom: 1px solid #f1f3f8;
    ::v-deep .el-textarea__inner {
      height: 160px;
      padding: 15px;
    }
    .button-submit {
      display: flex;
      justify-content: flex-end;
      .el-button {
        width: 104px;
        height: 32px;
        padding: 0;
        border-radius: 21px;
        font-size: 16px;
        margin: 20px 0;
      }
      .el-button--primary.is-disabled {
        background-color: $grey-font-color;
        border-color: $grey-font-color;
      }
      .quit-button {
        background-color: $grey-font-color;
        border-color: $grey-font-color;
        color: #fff;
        margin-right: 10px;
      }
    }
  }
  .noteList {
    min-height: 400px;
    .title {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      margin: 20px 0;
    }
    .list {
      margin-bottom: 30px;
      .name {
        font-size: 14px;
        font-weight: 400;
        color: $grey-font-color;
        line-height: 22px;
      }
      .content {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        word-break: break-all;
        white-space: pre-wrap;
        margin: 10px 0;
      }
      .prohibited-box {
        margin-bottom: 15px;
        padding: 8px 10px;
        background: rgba(225, 63, 55, 0.05);
        border-radius: 2px;
        font-size: 12px;
        color: $theme-color;
        line-height: 17px;
      }
      .dateWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .date {
          font-size: 12px;
          font-weight: 400;
          color: #bcc4d2;
          line-height: 17px;
        }
        .operation {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          div {
            display: flex;
            align-items: center;
            margin-left: 34px;
            cursor: pointer;
            i {
              display: inline-block;
              width: 24px;
              height: 24px;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              &.edit-icon {
                background-image: url("@/assets/image/edit.png");
              }
              &.delete-icon {
                background-image: url("@/assets/image/delete.png");
              }
            }
            span {
              font-weight: 400;
              font-size: 14px;
              line-height: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
